/**
 * Copyright © 2026 Adnuntius AS.
 */
import * as _ from 'lodash';
import {Component, Input, OnInit} from '@angular/core';
import {interpolateWarning} from "../common/directives/error/interpolate-warnings-filter";
import {TranslateService} from "@ngx-translate/core";

@Component({
  standalone: false,
  selector: 'creative-status-label',
  template: `<span class="label {{labelClass}}">{{ "creative.userState." + status | translate }}</span><info-icon *ngIf="warningsOutput && massagedWarnings.length > 0" [text]="this.warningsOutput" placement="bottom"></info-icon>`
})
export class CreativeStatusLabelComponent implements OnInit {
  @Input() warnings: any;
  @Input() status: string;
  massagedWarnings: any;
  warningsOutput: string;
  labelClass: string;
  deliverableText: string;
  labelClassDeliverable: string;

  constructor(public translate: TranslateService) {
  }

  ngOnInit(): void {
    this.labelClass = "label-success";
    this.deliverableText = "Deliverable";
    this.labelClassDeliverable = "label-success";

    const skipThese = ['validation.warning.creative.blocked.by.scanner'];
    this.massagedWarnings = _.filter(this.warnings, function (w) {
      return !_.includes(skipThese, w.code);
    });
    const adServerWarnings = _.filter(this.massagedWarnings, function (w) {
      return w.preventsAdServing;
    });

    if (this.status === 'REJECTED') {
      this.labelClass = "label-danger";
    } else if (this.status !== 'APPROVED') {
      this.labelClass = "label-warning";
    } else if (this.status === 'APPROVED' && adServerWarnings.length > 0 && this.massagedWarnings.length > 0) {
      this.labelClass = "label-danger";
      this.status = "UNDELIVERABLE";
    }

    this.warningsOutput = "<ul>";
    _.forEach(this.warnings, (warning) => {
      this.warningsOutput += "<li>" + interpolateWarning(warning) + "</li>";
    });
    this.warningsOutput += "</ul>";
  }
}
